import React from 'react';
import { useTheme } from '@mui/material/styles';

interface LogoProps {
  height?: number;
  color?: string;
}

export const Logo: React.FC<LogoProps> = ({
  height = 30,
  color = 'currentColor',
}) => {
  const width = height * 5.2;
  const theme = useTheme();

  // Electric blue for cursor - brighter and more vibrant
  const cursorColor = '#0ea5e9'; // Bright cyan-blue

  // Text color adapts to theme
  const textColor = theme.palette.mode === 'dark' ? '#e8eaed' : '#2d3748';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1040 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMid meet"
    >
      {/* Text - standard Courier typewriter font in dark blue */}
      <text
        x="0"
        y="155"
        fontFamily="'Courier New', Courier, monospace"
        fontSize="160"
        fontWeight="700"
        fill={textColor}
      >
        topstorie
      </text>

      {/* Cursor in electric blue - closer and taller */}
      <rect
        x="875"
        y="5"
        width="28"
        height="190"
        fill={cursorColor}
      />
    </svg>
  );
};
